export const sessionTimeOutWorker = () => {
    let sessionLogoutTimer;
    // eslint-disable-next-line no-restricted-globals
    self.onmessage = function (message) {
        if (message && message.data && message.data.msg === 'Logout-post-message') {
            sessionLogoutTimer = setTimeout(() => {
                postMessage('call-handleLogout');
            }, message.data.autoLogoutTime);
        }

        if (message && message.data && message.data.msg === 'clear-timeout') {
            clearTimeout(sessionLogoutTimer);
        }
    };
};